import React, { useState } from 'react';
import { Affix, Button, Dropdown, Menu, MenuProps, Spin } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styles from './FloatButton.module.scss';
import { NavLink } from 'react-router-dom';

interface Props {
  onClick?: React.MouseEventHandler<HTMLElement>;
  style? : string;
  children? : React.ReactElement | string;
  menu?: menu[]
  loading?: boolean;
}

type menu = {
  key:string;
  label:string;
  toLink?: string;
  action?: ()=>{};
  icon?:React.FC;
  disabled?: boolean;
  children?:menu[];
}

const FloatButton = ({onClick, style, children, menu, loading=false}:Props) => {
  
  const items = (): MenuProps['items'] => {
    return menu?.map((item) => {
      return {
        children: item.children,
        key: item.key,
        onClick: item.action,
      }
    })
  }

  return (
    <div className={style || styles.container}>
      <Spin spinning={loading}>
        { menu ?
          <Dropdown 
            className={styles.button} 
            overlay={getMenu(menu)}
            trigger={['click']}>
            <Button className={styles.button} type="primary" onClick={onClick && onClick}>
              {children || '+'}
            </Button>
          </Dropdown>
        : 
          <Button className={styles.button} type="primary" onClick={onClick && onClick}>
            {children || '+'}
          </Button>
        }
      </Spin>
    </div>
  )
}


const getMenu = (menu: menu[]) => (
  <Menu>
    {
      menu?.map((items) => {
        return (
          <>
            {
              items?.children ?
                <Menu.SubMenu key={items.key} title={items.label}>
                  {
                    items?.children.map(
                      (subItem) => {
                        return (
                          <Menu.Item key={subItem.key} onClick={() => items.action()}>
                            {
                              subItem.action ?
                                <span >{items.label}</span>
                                :
                                <NavLink
                                  to={subItem.toLink}
                                >
                                  {subItem.label}
                                </NavLink>
                            }
                          </Menu.Item>
                        )
                      }
                    )
                  }
                </Menu.SubMenu>
                :
                <Menu.Item key={items.key} onClick={() => items.action && items.action()}>
                  {
                    items.action ?
                      items.label
                      :
                      <NavLink
                        to={items.toLink}
                      >
                        {items.label}
                      </NavLink>
                  }
                </Menu.Item>
            }
          </>
        )
      }
      )
    }
  </Menu>
);

export default FloatButton;